import React, {useState} from "react";
import {PaginatedTable} from "components/table";
import TableRow from "@material-ui/core/TableRow";
import {injectIntl} from "react-intl";
import {Restricted, permissions} from "components/auth";
import {useMutation} from "@apollo/react-hooks";
import cn from "classnames";
import styles from "./groups-table.css";
import CustomTableRow from "../../../../../components/table/custom-table-row/custom-table-row";
import IconButton from "../../../../../components/icon-button/icon-button";
import Icon from "../../../../../components/icon/icon";
import DeleteActionWithModal from "../../../../../components/buttons/action-button/delete-action-with-modal";
import withStyles from "../../../../../components/with-styles/with-styles";
import PropTypes from "prop-types";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import DataGridItem from "../../../../../components/data-grid/data-grid-item";
import CameraListTable from "./camera-list-table";
import TextDisplay from "../../../../../components/display-data/text/text";
import {useParams} from "react-router-dom";
import Dialog from "components/dialog";
import SubdeploymentForm from "../subdeployment-form";
import {updateSubdeploymentMutation, deleteSubdeploymentMutation} from "../index";
import {GENERAL_STATUS_KO} from "../../../../../utils/constants";

const RowComponent = (props) => {
    const {classes, item, refetchData, intl} = props;
    const [deleteSubdeployment] = useMutation(deleteSubdeploymentMutation);
    const [updateSubdeployment] = useMutation(updateSubdeploymentMutation);
    const [editOpen, setEditOpen] = useState(false);
    const {id} = useParams();
    const isKo = item.lastStatus === GENERAL_STATUS_KO;

    const handleEditModal = e => {
        setEditOpen(editOpen => !editOpen);
        e.stopPropagation();
    };

    const onSuccess = () => {
        setEditOpen(true);
        refetchData();
    };

    return (
        <>
            <Dialog
                title={intl.formatMessage({id: "app.page.deployment.details.editSubdeployment"})}
                open={editOpen}
                fixed>
                <SubdeploymentForm
                    edit={true}
                    item={item}
                    query={updateSubdeployment}
                    intl={intl}
                    id={id}
                    handleClose={handleEditModal}
                    onSuccess={onSuccess}
                    classes={classes}/>
            </Dialog>
            <CustomTableRow key={item.id} className={cn({[classes.alert]: isKo})} onClick={() => {}}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header" className={classes.accordionSummary}>
                        <DataGridItem small className={classes.accordionText}>
                            <TextDisplay label={intl.formatMessage({id: "common.name"})}>{item.name}</TextDisplay>
                        </DataGridItem>
                        <DataGridItem small className={classes.accordionText}>
                            <TextDisplay
                                label={intl.formatMessage({id: "common.description"})}>{item.description}</TextDisplay>
                        </DataGridItem>
                        <DataGridItem className={classes.accordionButtons}>
                            <Restricted permissions={[permissions.deployment_manage]}>
                                <IconButton className={classes.iconButton} onClick={handleEditModal}>
                                    <Icon name="edit"/>
                                </IconButton>
                                <DeleteActionWithModal
                                    mutation={deleteSubdeployment}
                                    mutationVariables={{
                                        subdeploymentId: item.id,
                                        deploymentId: id,
                                    }}
                                    elementNameInResult="deleteSubdeployment"
                                    elementToDelete={item.description}
                                    refetchDataOnSuccess
                                    refetchData={refetchData}/>
                            </Restricted>
                        </DataGridItem>
                    </AccordionSummary>
                    <AccordionDetails className={classes.acordionDetails}>
                        <CameraListTable cameras={item.streamsourceIds} intl={intl}/>
                    </AccordionDetails>
                </Accordion>
            </CustomTableRow>
        </>
    );
};

RowComponent.propTypes = {
    /**
     ** Indica si muestra un enlace a la instalación
     **/
    showDeployment: PropTypes.bool,
    /**
     ** Elemento a representar en la fila de la tabla
     **/
    item: PropTypes.object,
    /**
     * Función de refetch de datos
     */
    refetchData: PropTypes.func.isRequired,
    /**
     ** Indica si se muestran los controles de borrar la asociación con el deployment
     **/
    showDeploymentAssociationControls: PropTypes.bool,
};

const I18nStyledRowComponent = injectIntl(withStyles(styles)(RowComponent));

const Header = () => (
    <TableRow/>
);

const GroupsTable = (props) => {
    const {groups, refetch} = props;
    return (
        <PaginatedTable
            paginatedElements={{items: groups, total: groups?.length}}
            headerComponent={Header}
            rowComponent={item => <I18nStyledRowComponent refetchData={refetch} item={item?.item} {...props}/>}
            showPagination={false}
        />
    )
};

export default injectIntl(withStyles(styles)(GroupsTable));